<template>
    <form-container :header-text="title" :valid-actions="['abmeldung', 'verlaengerung', 'wiederanmeldung']"
                    :width="450" :action="action" header-icon="mdi-card-account-details" @save="save()"
                    :button-ok="formSettings.buttonOk" :button-cancel="formSettings.buttonCancel"
                    :buttonOkColor="formSettings.buttonOkColor">
        <v-card-text v-if="pendingUmmeldung && action === 'abmeldung'" class="px-6">
            <p>Du kannst Mitglied <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span> (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                nicht abmelden, da du auch eine Ummeldung angefordert hast.</p>
            <p>Diese Ummeldung ist vom Passreferenten noch nicht bearbeitet worden!</p><p><span class="font-weight-bold">
                Bitte storniere diese Ummeldung falls du das Mitglied abmelden möchtest.</span></p>
        </v-card-text>
        <v-card-text v-else-if="pendingPassDuplikat && action === 'abmeldung'" class="px-6">
            <p>Du kannst Mitglied <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span> (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                nicht abmelden, da du auch ein Passduplikat angefordert hast.</p>
            <p>Diese Anforderung ist vom Passreferenten noch nicht bearbeitet worden!</p><p><span class="font-weight-bold">
                Bitte storniere diese Anforderung falls du das Mitglied abmelden möchtest.</span></p>
        </v-card-text>
        <v-card-text v-else-if="pendingVerlaengerung && action === 'abmeldung'" class="px-6">
            <p>Du kannst Mitglied <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span> (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                nicht abmelden, da du auch ein Pass-Verlängerung angefordert hast.</p>
            <p>Diese Verlängerung ist vom Passreferenten noch nicht bearbeitet worden!</p><p><span class="font-weight-bold">
                Bitte storniere diese Verlängerung falls du das Mitglied abmelden möchtest.</span></p>
        </v-card-text>
        <v-card-text v-else-if="actionObject && actionSettings && !actionSettings.pending && action !== 'abmeldung'" class="px-6">
            <p class="mb-2">Möchstes du <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span>
            (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                wirklich {{actionVerb}}?</p>
            <p v-if="action==='wiederanmeldung'">Falls ja prüfe bitte das vorgeschlagene Sportjahr und ändere es bei Bedarf:</p>
            <v-select v-model="sportJahrSelected" :items="sportJahrItems"
                      label="Sportjahr" :rules="[rules.required]"></v-select>
            <v-textarea v-model="actionObject.comment" filled rows="3"
                          label="Bemerkungen" >
            </v-textarea>
        </v-card-text>
    <!-- Abmeldung Content -->
        <v-card-text v-else-if="actionObject && actionSettings && !actionSettings.pending &&
                                action === 'abmeldung' && !pendingAbmeldung" class="px-6">
            <v-radio-group v-model="deleteOption" class="mt-0">
                <template v-slot:label>
                    <p class="mb-2">Möchstes du <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
                        {{actionObject.spieler.nachname}}</span>
                        (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)</p>
                </template>
                <v-radio value="sportJahr">
                    <template v-slot:label>
                        <div>mit Ende des Sportjahres <strong>{{sportJahr.abmeldung.text}}</strong> abmelden</div>
                    </template>
                </v-radio>
                <v-radio value="immediate">
                    <template v-slot:label>
                        <div>mit diesem Tag abmelden </div>
                        <v-text-field type="date" class="pl-3"
                                      v-model="actionObject.actionDate" :rules="[rules.required]">
                        </v-text-field>
                    </template>
                </v-radio>
            </v-radio-group>
            <v-textarea v-model="actionObject.comment" filled rows="3"
                          label="Bemerkungen bzw. Begründungen"></v-textarea>
        </v-card-text>
    <!-- cancel -->
        <v-card-text v-else-if="actionObject && actionSettings && actionSettings.pending && !blockRefresh" class="px-6">
            <p>Du hast für <span class="font-weight-bold warning--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span>
                (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
                vor <span class="font-weight-bold warning--text">{{timeSince}}</span>
                eine {{actionNoun}} angefordert.</p>
            <p><span class="font-weight-bold">Diese {{actionNoun}} ist vom Passreferenten
                noch nicht bearbeitet worden!</span></p>
            <p> Möchstest du die {{actionNoun}} stornieren?</p>
        </v-card-text>
    <!-- error message -->
        <error-msg :error="errorMsg" class="mx-6"></error-msg>
    </form-container>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import {FormRules} from "../../../services/formRules";
    import SpielerActionIconList from "../../../services/data/spielerActionIcons/spielerActionIconList";
    import TimeStamp from "../../../services/timeStamp";
    import SPIELER_CHANGE_HANDLER from "../../../services/data/spieler/spielerChangeHandler";
    import ErrorMsg from "../../../components/elements/errorMsg";

    export default {
        components: {
            ErrorMsg,
            FormContainer},
        name: "spieler-status",
        props: ['spieler', 'action', 'actionObject', 'lv'],
        data: () => ({
            blockRefresh: false,
            rules: null,
            deleteOption: 'sportJahr',
            sportJahrSelected: '',
            sportJahrItems: [],
            errorMsg: '',
        }),
        computed: {
            sportJahr(){ return this.$store.state.local.sportJahr; },
            cancelFlag() {return this.actionSettings && this.actionSettings.pending ? 'Cancel' : ''},
            title() {
                switch (this.action + this.cancelFlag) {
                    case 'abmeldung': return 'Mitglied abmelden';
                    case 'abmeldungCancel': return 'Anmeldung stornieren';
                    case 'wiederanmeldung': return 'Mitglied wieder anmelden';
                    case 'wiederanmeldungCancel': return 'Abmeldung stornieren';
                    case 'verlaengerung':return 'Pass verlängern';
                    case 'verlaengerungCancel':return 'Pass-Verlängerung stornieren';
                }
                return '';
            },
            actionNoun(){
                switch (this.action + this.cancelFlag) {
                    case 'abmeldung': return 'Abmeldung';
                    case 'abmeldungCancel': return 'Wiederanmeldung';
                    case 'wiederanmeldung': return 'Wiederanmeldung';
                    case 'wiederanmeldungCancel': return 'Abmeldung';
                    case 'verlaengerung': case 'verlaengerungCancel': return 'Verlängerung';
                }
                return '';
            },
            actionVerb(){
                switch (this.action + this.cancelFlag) {
                    case 'abmeldung': return 'abmelden';
                    case 'wiederanmeldung': return 'wieder anmelden';
                    case 'verlaengerung': return 'den Pass ab dem folgenden Sportjahr verlängern';
                }
                return '';
            },
            pendingActions() { return this.$store.state.realtime.pendingActions },
            actionSettings () {
                if ( !this.actionObject ) { return null }
                let action = this.action;
                let spieler = this.actionObject.local.spieler;
                if ( this.action === 'wiederanmeldung' ) {
                    action = 'abmeldung';
                    spieler = JSON.parse(JSON.stringify( spieler ));
                    spieler.status = 'aktiv';
                } else if (  this.action === 'abmeldung' ) {
                    action = 'wiederanmeldung';
                    spieler = JSON.parse(JSON.stringify( spieler ));
                    spieler.status = 'inaktiv';
                }
                return SpielerActionIconList[action]( spieler, this.pendingActions);
            },
            formSettings() {
                return this.actionSettings ?
                    {   buttonOkColor: this.otherPending ? '' :
                                  !this.actionSettings.pending ? 'primary' : 'warning',
                        buttonOk: this.otherPending ? 'ok' :
                                  !this.actionSettings.pending ? 'Ja' : 'endgültig stornieren',
                        buttonCancel: this.otherPending ? '' :
                                  !this.actionSettings.pending ? 'Nein' : 'abbrechen',
                    } :
                    {   buttonOkColor: 'primary',
                        buttonOk: 'Ja',
                        buttonCancel: 'Nein',
                    };
            },
            timeSince(){
                return this.actionSettings ?
                      TimeStamp.getTimeSince(this.actionSettings.pending.createdAt) : '';
            },
            pendingAbmeldung(){
                return this.actionObject ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.actionObject.local.spieler.id &&
                    pendingAction.actionType === 'abmeldung' ).length > 0 : false;
            },
            pendingUmmeldung(){
                return this.actionObject ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.actionObject.local.spieler.id &&
                    pendingAction.actionType === 'ummeldung' ).length > 0 : false;
            },
            pendingPassDuplikat(){
                return this.actionObject ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.actionObject.local.spieler.id &&
                    pendingAction.actionType === 'passDuplikat' ).length > 0 : false;
            },
            pendingVerlaengerung(){
                return this.actionObject ? this.pendingActions.filter(pendingAction =>
                    pendingAction.search_spieler === this.actionObject.local.spieler.id &&
                    pendingAction.actionType === 'verlaengerung' ).length > 0 : false;
            },
            otherPending() { return (this.pendingUmmeldung || this.pendingVerlaengerung || this.pendingPassDuplikat) &&
                                     this.action === 'abmeldung'; }
        },
        created(){
            this.rules = new FormRules();
            if ( this.action ) { this.setSportJahr(); }
        },
        methods: {
            setSportJahr(){
                this.sportJahrItems = this.action === 'verlaengerung' ?
                    this.sportJahr.verlaengerung : this.sportJahr.anmeldeList;
                this.sportJahrSelected = this.action === 'verlaengerung' ?
                    this.sportJahr.verlaengerung[this.sportJahr.verlaengerung.length-1].value :
                    this.sportJahr.current.value;
            },
            async save(){
                this.errorMsg = '';
                console.log ("SPIELER !!!", this.actionObject.local);
                if ( this.otherPending ) {
                    window.history.back();
                }
                this.actionObject.setSpielerTemp(this.spieler);
                if ( this.actionSettings.pending ) {
                // cancel spielerAction
                    // undo spieler
                        // required because abmeldung cancel is called from wiederanmeldung and
                        // wiederanmeldung cancel is called from abmeldung (controlled via action settings
                        const actionTemp = this.action === 'verlaengerung' ?
                            this.action : this.actionSettings.actionType;
                        // set document updates
                        this.actionObject.local.spieler.local.documentUpdates = this.getUpdatesForCancel(actionTemp);
                        await this.actionObject.local.spieler.updateWithTransaction('spieler_edit', false);
                    // cancel action
                        this.cancelAction();
                } else {
                        this.errorMsg = this.actionObject.setActionDateForExcelDownload(this.action, this.deleteOption,
                                                                                        this.sportJahrSelected);
                        if ( this.errorMsg ){ return; }
                // new spielerAction
                    // log current memberships in actionObject for undo
                        this.actionObject.setUndo(
                            {memberships: this.actionObject.local.spieler.memberships,
                            gesperrtAb: this.actionObject.local.spieler.dates.gesperrtAb }
                        );
                    // change spieler
                        if ( this.action !== 'abmeldung' ) { await this.actionObject.local.spieler.setPrivateDataFromDB() }
                        this.actionObject.local.spieler.local.documentUpdates = this.getUpdates();
                        await this.actionObject.local.spieler.updateWithTransaction('spieler_edit', false);
                    // save action object
                        this.saveNew();
                }
            },
                getUpdates(){
                    let updates = null;
                    switch (this.action) {
                        case 'abmeldung':
                            updates = SPIELER_CHANGE_HANDLER.getDataObjectForAbmeldung( this.actionObject.local.spieler,
                                                                            this.deleteOption, this.actionObject.actionDate);
                            break;
                        case 'wiederanmeldung':
                            updates = SPIELER_CHANGE_HANDLER.getDataObjectForWiederanmeldung( this.actionObject.local.spieler,
                                                                                            this.sportJahrSelected, this.lv );
                            break;
                        case 'verlaengerung':
                            updates = SPIELER_CHANGE_HANDLER.getDataObjectForVerlaengerung( this.actionObject.local.spieler,
                                this.sportJahrItems.find(sportJahr => sportJahr.id === this.sportJahrSelected),
                                this.lv);
                            break;
                    }
                    return updates;
                },
                getUpdatesForCancel(action){
                    let updates = null;
                    switch (action) {
                        case 'abmeldung':
                            updates = SPIELER_CHANGE_HANDLER.getDataObjectForCancel( this.actionObject.local.spieler,
                                                                                            this.actionSettings.pending,
                                                                                            'abmeldung');
                            break;
                        case 'wiederanmeldung':
                            updates = SPIELER_CHANGE_HANDLER.getDataObjectForCancel( this.actionObject.local.spieler,
                                                                                            this.actionSettings.pending,
                                                                                            'wiederanmeldung');
                            break;
                        case 'verlaengerung':
                            updates = SPIELER_CHANGE_HANDLER.getDataObjectForVerlaengerungCancel( this.actionObject.local.spieler,
                                                                                            this.actionSettings.pending );
                            break;
                    }
                    return updates;
                },
            saveNew(){
                console.log ("this.actionObject.local.spieler.local", this.actionObject.local.spieler.local);
                this.actionObject.changes.push(
                    {   field: 'lastSportTag',
                        valueOld: this.actionObject.local.spieler.dates.lastSportTag,
                        valueNew: this.actionObject.local.spieler.local.documentUpdates['dates.lastSportTag'] }
                );
                this.blockRefresh = true;
                setTimeout(()=>{ this.blockRefresh = false },1000);
                const printPass = this.actionObject.actionType !== 'abmeldung'
                const clearPassPrint = this.actionObject.actionType === 'abmeldung'
                this.$emit('saveAction', this.actionObject,
                    { success: 'Die ' + this.actionNoun + ' wurde erfolgreich beantragt!'},
                    printPass, false, true, clearPassPrint
                );
                window.history.back();
            },
            cancelAction(){
                this.$emit('cancelAction', this.actionSettings.pending, this.actionObject);
                window.history.back();
            },
        },
        watch: {
            action(){
                this.setSportJahr();
            }
        }
    }
</script>

<style scoped>

</style>